import DOMPurify from 'dompurify';

// API and generated HTML must cross this boundary before entering the DOM.
export function sanitizeHtml(html) {
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}

// Generated documents reference these existing, application-owned stylesheets.
// Render them through React, rather than retaining arbitrary link tags in HTML.
const generatedStylesheets = new Set([
  '/assets/css/dwg-core.css',
  '/assets/css/dwg-domain.css',
  'styles.css',
  '/styles.css',
]);

export function extractGeneratedStylesheets(html) {
  const document = new window.DOMParser().parseFromString(html, 'text/html');
  return [...new Set(
    [...document.querySelectorAll('link[rel="stylesheet"]')]
      .map((link) => link.getAttribute('href'))
      .filter((href) => generatedStylesheets.has(href)),
  )];
}
